export default (value: number) => {
    switch (value) {
        case 1:
            return "CV Parser";
        default:
            return "Unknown";
    }
}
